// Core Modules
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';

// External Modules
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

// Services
import { ConfigService } from '@core/services/config/config.service';

@Component({
  selector: 'app-session-expiry-notification',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './session-expiry-notification.component.html',
  styleUrl: './session-expiry-notification.component.scss',
})
export class SessionExpiryNotificationComponent implements OnInit, OnDestroy {
  // Bindings
  @Input() userName?: string;

  // Injectors
  private readonly ngbActiveModal = inject(NgbActiveModal);
  private readonly configService = inject(ConfigService);

  // Private Members
  private notifyTimerInterval: any;

  // Public Members
  public expireInSeconds: number = 0;

  constructor() {
    this.expireInSeconds = this.configService.logoutNotifyExpiryTime;
  }

  public ngOnInit(): void {
    this.notifyTimerInterval = setInterval(() => {
      if (this.expireInSeconds > 0) {
        this.expireInSeconds--;
      } else {
        clearInterval(this.notifyTimerInterval);
        this.forceLogout();
      }
    }, 1000);
  }

  public continue(): void {
    clearInterval(this.notifyTimerInterval);
    this.ngbActiveModal.close('continue');
  }

  public forceLogout(): void {
    clearInterval(this.notifyTimerInterval);
    this.ngbActiveModal.close('logout');
  }

  public ngOnDestroy(): void {
    clearInterval(this.notifyTimerInterval);
  }
}
